import {
  StoryblokComponent,
  storyblokEditable,
  renderRichText,
} from "@storyblok/react";
import { Breadcrumb } from "./Breadcrumb";
import { Mail, Binary, BadgeDollarSign, ChartScatter } from "lucide-react";

const Nonprofitfeatures = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display ">
      <div className="container herosub">
        <Breadcrumb currentName={blok.title} />
        <h1>{blok.title}</h1>
        <h2>{blok.subtitle}</h2>
      </div>

      <div className="font-display text-left npf-content">
        <div className="messaging-center">
          <div className="messaging-center-content">
            <div className="icon-wrapper">
              <Mail size={32} className="button-icon" />
            </div>
            <p className="preamble">{blok.mcpreamble}</p>
            <h2>{blok.mctitle}</h2>
            <p>{blok.mccopy}</p>
          </div>
          <div className="messaging-center-image">
            <img
              src={blok.messagingimage.filename}
              alt={blok.messagingimage.alt}
            />
          </div>
        </div>
        <div className="messaging-center-grid">
          <div className="card-grid">
            {blok.columns
              ? blok.columns.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>
        <div
          className="quote"
          dangerouslySetInnerHTML={{ __html: renderRichText(blok.quote) }}
        />

        <div className="powerbi">
          <div className="powerbi-content-wrapper">
            <div className="powerbi-image">
              <img src={blok.pbiimage.filename} alt={blok.pbiimage.alt} />
            </div>
            <div className="powerbi-content">
              <div className="icon-wrapper">
                <ChartScatter size={32} className="button-icon" />
              </div>
              <p className="preamble">{blok.pbipreamble}</p>
              <h2>{blok.pbititle}</h2>
              <p>{blok.pbicopy}</p>
            </div>
          </div>
          <div className="powerbi-grid">
            <div className="card-grid">
              {blok.pbigrid
                ? blok.pbigrid.map((blok) => (
                    <StoryblokComponent blok={blok} key={blok._uid} />
                  ))
                : null}
            </div>
          </div>
        </div>
        <div className="redemption-codes">
          <div className="icon-wrapper">
            <Binary size={32} className="button-icon" />
          </div>
          <p className="preamble">{blok.rcpreamble}</p>
          <h2>{blok.rctitle}</h2>
          <p>{blok.rccopy}</p>
          <div className="card-grid">
            {blok.rccolumns
              ? blok.rccolumns.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>

        <div className="donation-processors">
          <div className="icon-wrapper">
            <BadgeDollarSign size={32} className="button-icon" />
          </div>
          <p className="preamble">{blok.dppreamble}</p>
          <h2>{blok.dptitle}</h2>
          <p>{blok.dpcopy}</p>
          <div className="card-grid">
            {blok.dpcolumns
              ? blok.dpcolumns.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
          <div className="dp-summary">
            <h3>{blok.dpsummarytitle}</h3>
            <p>{blok.dpsummarycopy}</p>
          </div>
        </div>
      </div>

      <div className="form-container">
        <div className="form-pre">
          <h2>Your path to increased revenue starts here</h2>
        </div>
        <div className="form">
          {blok.form
            ? blok.form.map((blok) => (
                <StoryblokComponent blok={blok} key={blok._uid} />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default Nonprofitfeatures;
